<app-nav-menu></app-nav-menu>
<dx-load-panel [(visible)]="isLoadPanelVisible"></dx-load-panel>
<p-toast></p-toast>
<main class="pl-5 pr-5 h pax-main-body">
  <div class="container-fluid protect-form">
    <span class="text-success mb-3">Dashboard <i class="fas fa-angle-right"></i> Issue </span>
    <div class="que_travel mb-5 pl-0">UNITED TRAVEL INSURANCE</div>
    <div class="note col-sm-12">
      <p-checkbox [(ngModel)]="isCovidCovered" [binary]="true" inputId="isCovidCovered" name="isCovidCovered" label="Would you like to cover COVID-19?" (onChange)="CovidCoverage()"></p-checkbox>
    </div>




    <div class=" col-sm-12 mt-5">
      <div class="protect-terms-rules-heading">Trip Details</div>
      <div class="row">
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          <label  class="labelofmodifyserachinputs">Destination *</label>
          <p-select class="segmentDropdown"
            placeholder="SELECT Destination"
            name="destination"
            [options]="destination"
            [(ngModel)]="passengerInfoBaseObj.destination"
            optionLabel="name"
            optionValue="code"
          (onChange)="DestinationChange($event)"></p-select>
          @if (ValidationChck && !passengerInfoBaseObj.destination) {
            <div>
              <span class="error_class">Destination Required</span>
            </div>
          }
        </div>
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          <label class="labelofmodifyserachinputs">NO OF DAYS *</label>
          <p-select class="segmentDropdown" placeholder="SELECT NO OF DAYS" name="NOD" [options]="noOFDays" [(ngModel)]="passengerInfoBaseObj.noOfDays" optionLabel="name" optionValue="code" (onChange)="planTypeChange($event)"></p-select>
          @if (ValidationChck && !passengerInfoBaseObj.noOfDays) {
            <div>
              <span class="error_class">Days Required</span>
            </div>
          }
        </div>
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          <p-select
            class="segmentDropdown"
            name="destination"
            placeholder="Select Destination Country"
            [(ngModel)]="passengerInfoBaseObj.destinationCountry"
            [options]="countryList"
            optionLabel="countryName"
            optionValue="countryName"
            [filter]="true"
            filterBy="countryName">
          </p-select>
          <label class="labelofmodifyserachinputs">COUNTRY OF DESTINATION *</label>
          @if (ValidationChck && !passengerInfoBaseObj.destinationCountry) {
            <div>
              <span class="error_class">Country Required</span>
            </div>
          }
        </div>
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          <input type="date" class="inputStyle" name="travelDate" [min]="minDate" [(ngModel)]="passengerInfoBaseObj.travelDate" view="date" >
          <label class="labelofmodifyserachinputs">TRAVEL DATE *</label>
          @if (ValidationChck && !passengerInfoBaseObj.travelDate) {
            <div>
              <span class="error_class">Travel Date Required</span>
            </div>
          }
        </div>
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          <label class="labelofmodifyserachinputs">ARE YOU TRAVELLING ALONE OR WITH FAMILY? *</label>
          <p-select class="segmentDropdown" placeholder="ARE YOU TRAVELLING ALONE OR WITH FAMILY?" name="selectedPlanType" [options]="planTypes" [(ngModel)]="passengerInfoBaseObj.planType" optionLabel="name" optionValue="code" (onChange)="planTypeChange($event)"></p-select>
          @if (ValidationChck && !passengerInfoBaseObj.planType) {
            <div>
              <span class="error_class">Travel Status Required</span>
            </div>
          }
        </div>
        <div class="col-lg-3 col-md-6 col-cm-12 p-3" >
          @if (isFamily) {
            <div>
              <label class="labelofmodifyserachinputs">
                NUMBER OF CHILDREN TRAVELLING WITH YOU *
              </label>
              <p-select
                class="segmentDropdown"
                placeholder="SELECT NUMBER OF CHILDREN"
                name="numberOfChildren"
                [options]="childOptions"
                [(ngModel)]="passengerInfoBaseObj.numberOfChildren"
                optionLabel="name"
                optionValue="code"
                (onChange)="selectedIndexChildren($event)">
              </p-select>
              @if (ValidationChck && !passengerInfoBaseObj.numberOfChildren) {
                <div>
                  <span class="error_class">Children Count Required</span>
                </div>
              }
            </div>
          }
        </div>
      </div>

    </div>



    <div class="protect-terms-rules col-sm-12">
      <div class="protect-terms-rules-heading">TRAVELLER DETAILS</div>
      <div>
        <div class="row col-12 mt-3">
          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <label class="labelofmodifyserachinputs" >CNIC NO *</label>
            <input type="text" class="inputStyle" name="cnic" [(ngModel)]="passengerInfoBaseObj.principalTraveller.nicNo" (keydown)="onDashPress($event)">
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.nicNo) {
              <div>
                <span class="error_class">CNIC Required</span>
              </div>
            }
          </div>
          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <label class="labelofmodifyserachinputs">FULL NAME *</label>
            <input type="text" class="inputStyle" name="TravelerName" [(ngModel)]="passengerInfoBaseObj.principalTraveller.fullName" (keydown)="onSpacePress($event)" required>
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.fullName) {
              <div>
                <span class="error_class">Fullname Required</span>
              </div>
            }
          </div>
          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <input type="date" class="inputStyle" [max]="maxDate" name="DOB" [(ngModel)]="passengerInfoBaseObj.principalTraveller.dob" view="date">
            <label class="labelofmodifyserachinputs">DOB *</label>
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.dob) {
              <div>
                <span class="error_class">DOB Required</span>
              </div>
            }
          </div>
          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <label class="labelofmodifyserachinputs">PASSPORT NO *</label>
            <input type="text" class="inputStyle" name="passportNo" [(ngModel)]="passengerInfoBaseObj.principalTraveller.passportNo" required>
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.passportNo) {
              <div>
                <span class="error_class">Passport# Required</span>
              </div>
            }
          </div>

          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <label class="labelofmodifyserachinputs">CONTACT NO *</label>
            <input type="tel" class="inputStyle" name="contactNo" [(ngModel)]="passengerInfoBaseObj.principalTraveller.contactNo" required>
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.contactNo) {
              <div>
                <span class="error_class">Contact# Required</span>
              </div>
            }
          </div>

          <div class=" col-lg-4 col-md-4 col-sm-6 p-3">
            <label class="labelofmodifyserachinputs">NTN NO. </label>
            <input type="text" class="inputStyle" name="ntnNo" [(ngModel)]="passengerInfoBaseObj.principalTraveller.ntnNo">
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.ntnNo) {
              <div>
                <span class="error_class">NTN# Required</span>
              </div>
            }
          </div>

        </div>
        <div class="row col-12 mt-3">

          <div class=" col-lg-4 col-md-4 col-sm-12 p-3">
            <label class="labelofmodifyserachinputs">ADDRESS *</label>
            <input type="text" class="inputStyle" name="address" [(ngModel)]="passengerInfoBaseObj.principalTraveller.address" (keydown)="onSpacePress($event)" required>
            @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.address) {
              <div>
                <span class="error_class">Address Required</span>
              </div>
            }
          </div>
        </div>
        <hr />


        <div class="mt-5">
          <div class="protect-terms-rules-heading">BENEFICIARY DETAILS (<span style="font-weight:400 !important"> PERSON TO CONTACT IN CASE OF EMERGENCY </span>)</div>
          <div class="row col-12">
            <div class=" col-lg-4 col-md-3 col-sm-6 p-3">
              <label class="labelofmodifyserachinputs">BENEFICIARY NAME *</label>
              <input type="text" class="inputStyle" name="bname" [(ngModel)]="passengerInfoBaseObj.principalTraveller.beneficiaryName" (keydown)="onSpacePress($event)" required>
              @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.beneficiaryName) {
                <div>
                  <span class="error_class">Beneficiary Name Required</span>
                </div>
              }
            </div>
            <div class=" col-lg-4 col-md-3 col-sm-6 p-3">
              <label class="labelofmodifyserachinputs">PHONE *</label>
              <input type="tel" class="inputStyle" name="bphone" [(ngModel)]="passengerInfoBaseObj.principalTraveller.beneficiaryPhone" required>
              @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.beneficiaryPhone) {
                <div>
                  <span class="error_class">Beneficiary Phone Required</span>
                </div>
              }
            </div>
            <div class="col-lg-4 col-md-3 col-sm-6 p-3">
              <label class="labelofmodifyserachinputs">
                Relationship With Beneficiary
              </label>
              <p-select
                class="segmentDropdown"
                placeholder="Select Beneficiary"
                name="Beneficiary"
                [options]="BeneficiaryList"
                [(ngModel)]="passengerInfoBaseObj.principalTraveller.relationship"
                optionLabel="name"
                optionValue="code">
              </p-select>
              @if (ValidationChck && !passengerInfoBaseObj.principalTraveller.relationship) {
                <div>
                  <span class="error_class">Relationship Required</span>
                </div>
              }
            </div>
          </div>

        </div>
        <hr />
        @if (isFamily) {
          <div class="mt-5">
            <div class="protect-terms-rules-heading">FAMILY MEMBERS DETAILS **</div>
            <div class="col-12">
              <!--=========================Spouse=============================-->
              <div class="row col-12 m-3">
                <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                  <input type="text" class="inputStyle" name="SpouseName" [(ngModel)]="passengerInfoBaseObj.principalTraveller.spouseName" (keydown)="onSpacePress($event)" required>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">SPOUSE NAME *</label>
                </div>
                <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                  <!-- <p-datepicker class="dobInput" name="SpouseDOB" [(ngModel)]="passengerInfoBaseObj.principalTraveller.spouseDOB" view="date" [yearNavigator]="true" dateFormat="dd MM yy" yearRange="{{yearLowerLimit}}:{{currentYearLimit}}" required></p-datepicker> -->
                  <input type="date" class="inputStyle" name="SpouseDOB" [(ngModel)]="passengerInfoBaseObj.principalTraveller.spouseDOB" >
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">SPOUSE DOB *</label>
                </div>
                <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                  <input type="text" class="inputStyle" name="SpousePassportNo" [(ngModel)]="passengerInfoBaseObj.principalTraveller.spousePassport" required>
                  <span class="highlight"></span>
                  <span class="bar"></span>
                  <label class="labelofmodifyserachinputs">SPOUSE PASSPORT NO *</label>
                </div>
                <!--<div class="group col-lg-3 col-md-3 col-sm-6">
                <span (click)="RemoveFamilyMember(m)"><button class="subscribe btn shadow-sm text-uppercase"><i class="fas fa-trash"></i></button></span>
              </div>-->
            </div>
            <!--=========================Child 1=============================-->
            @if (passengerInfoBaseObj.numberOfChildren >= 1) {
              <div>
                @for (i of selectedChild; track i; let index = $index) {
                  <div class="parentChild">
                    <div class="row col-12 m-3">
                      <!-- Child Name -->
                      <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                        <input
                          type="text"
                          class="inputStyle"
                          name="ChildName{{ index }}"
                          [(ngModel)]="passengerInfoBaseObj.children[index].name"
                          (keydown)="onSpacePress($event)"
                          required />
                          <span class="highlight"></span>
                          <span class="bar"></span>
                          <label
                      [ngClass]="roeSubmission && !passengerInfoBaseObj.children[index].name
                        ? 'labelofmodifyserachinputsError'
                        : 'labelofmodifyserachinputs'">
                            CHILD {{ i }} NAME *
                          </label>
                        </div>
                        <!-- DOB -->
                        <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                          <input
                            type="date"
                            class="inputStyle"
                            name="ChildDOB{{ index }}"
                            [(ngModel)]="passengerInfoBaseObj.children[index].dob"
                            required />
                            <span class="highlight"></span>
                            <span class="bar"></span>
                            <label
                      [ngClass]="roeSubmission && !passengerInfoBaseObj.children[index].dob
                        ? 'labelofmodifyserachinputsError'
                        : 'labelofmodifyserachinputs'">
                              CHILD {{ i }} DOB *
                            </label>
                          </div>
                          <!-- Passport -->
                          <div class=" col-lg-3 col-md-3 col-sm-6 p-3">
                            <input
                              type="text"
                              class="inputStyle"
                              name="ChildPassport{{ index }}"
                              [(ngModel)]="passengerInfoBaseObj.children[index].passport"
                              required />
                              <span class="highlight"></span>
                              <span class="bar"></span>
                              <label
                      [ngClass]="roeSubmission && !passengerInfoBaseObj.children[index].passport
                        ? 'labelofmodifyserachinputsError'
                        : 'labelofmodifyserachinputs'">
                                CHILD {{ i }} PASSPORT *
                              </label>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <span class="text-danger mb-3">** Maximum 4 family members are allowed alongwith spouse. All info fields are mandatory for a member i.e. Name, DOB, Passport Number. If you have fewer members than 4, please leave all fields blank for that particular member and fill all data for only accompanying member.</span>
              </div>
            }
            <div class="row col-12 mt-5 mb-3">
              <div class="col-lg-3 col-md-3 col-sm-4"></div>
              <div class="col-lg-7 col-md-7 col-sm-4"></div>
              <div class="col-lg-2 col-md-2 col-sm-4" (click)="GetPackagesDetailByTravelPeriodWithCovid()"><button class="subscribe btn btn-block shadow-sm text-uppercase">Continue <i class="fas fa-angle-double-right"></i></button></div>
            </div>
          </div>

          @if (showDetails) {
            <div class="container-fluid bg-light py-3">
              <!--<div class="p-4 col-12" *ngIf="numberOfPassengers > 0 && numberOfPassengers < 3; else NotEligible" style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr;gap: 0.5rem;">-->
              <div class="p-4 col-12" style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr;gap: 0.5rem;">
                @for (pkg of GetPackagesDetailByTravelPeriodWithCovidResList; track pkg; let i = $index) {
                  <div class="card p-3">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                      <label class="input_lab"></label>
                      <span class="input_lab_value">
                        <img src="assets/img/UICLogo.png" alt="travel insurance details" id="link{{i}}" title="See coverage detail" style="cursor:pointer"
                          (click)="toggleWithAnimationOptions(i,pkg)" />
                          <p-dialog header="Package Plan Coverage Detail ( {{pkg.plan}} )" [(visible)]="popoverArray[i]" [style]="{width: '50vw'}">
                            @for (seg of PackageBenefits; track seg; let p = $index) {
                              <div class="border-dark m-2 p-1">
                                <div class="d-flex justify-content-between">
                                  <label class="input_lab_value">Benefits:</label>
                                  <span class="input_lab">{{seg.benefits}}</span>
                                </div>
                                <div class="d-flex justify-content-between">
                                  <span class="input_lab">Coverage</span>
                                  <span class="input_lab_value">{{seg.price}}</span>
                                </div>
                              </div>
                            }
                          </p-dialog>
                        </span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="input_lab">Duration (in days): </label>
                        <span class="input_lab_value">{{pkg.duration}}</span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="input_lab">Area Short Code:</label>
                        <span class="input_lab_value">{{pkg.areaShortCode}}</span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="input_lab">Area:</label>
                        <span class="input_lab_value">{{pkg.area}}</span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="input_lab">Plan:</label>
                        <span class="input_lab_value">{{pkg.plan}}</span>
                      </div>
                      <div class="d-flex justify-content-between align-items-center">
                        <label class="input_lab">Plan Type: </label>
                        <span class="input_lab_value">{{pkg.planType == "S" ? "Single" : "Family"}}</span>
                      </div>
                      <!-- <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Premium: </label>
                      <span class="input_lab_value">{{pkg.premium}}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Gross Premium: </label>
                      <span class="input_lab_value">{{pkg.grossPremium}}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Advance Tax: </label>
                      <span class="input_lab_value">{{pkg.advanceTax}}</span>
                    </div> -->
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Premium Amount: </label>
                      <span class="input_lab_value">{{pkg.passengerFares.baseFareAmount}}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Total Tax: </label>
                      <span class="input_lab_value">{{pkg.passengerFares.taxAmount}}</span>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <label class="input_lab">Total Payable Premium: </label>
                      <span class="input_lab_value">{{pkg.passengerFares.agencyTotalPrice}}</span>
                    </div>
                    <button class="btn btn-warning" (click)="selectPackage(pkg)" [disabled]="(pkg.planType == 'F' && passengerInfoBaseObj.noOfPassengers < 2) || (pkg.planType == 'S' && passengerInfoBaseObj.noOfPassengers > 1)">Select</button>
                  </div>
                }
              </div>
            </div>
          }


          @if (notDetails) {
            <div class="container-fluid bg-light py-3">
              <div class="font-weight-bold text-center mx-auto my-5 p-5">
                NO PLANS AVAILABLE!
              </div>
            </div>
          }
        </div>





        @if (DetailsCompleted) {
          <div class="plans-cards">
            <div class="row justify-content-evenly">
              <!-- Left Section -->
              <h1 class="main-heading">INSURANCE DETAILS</h1>
              <div class="col-12 col-lg-8 col-md-12">
                <div class="row justify-content-evenly">
                  @for (card of genericResponse?.genericResponse?.availablePlansRevenue; track card; let f = $index) {
                    <div  class="col-10 col-sm-6 col-md-5 m-3" id="resultsSection" >
                      <div  class="solution_card summary-card" id="solution_card{{f}}"
                        [class.active-card]="previousIndex === f" (click)="planDetailsDisplay(card,f)">
                        <div class="card-heading">
                        <div class="insurance-image" [ngStyle]="{
                            'width': '100%',
                            'height': '30vh',
                            'background': 'linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(0, 0, 0, 1)), url(' + getValidImageUrl(card.planAdditionalInfoDesc) + ')',
                            'background-size': 'cover',
                            'background-position': 'center',
                            'background-repeat': 'no-repeat',
                            'border-radius': '15px'
                          }"></div>
                          <div class="insurance-header">
                            <h3>{{ card.planTitle }}</h3>
                            <p class="text-card">{{ card.planDesc }}</p>
                            <p class="text-card">Starting From <b> {{ card.currencyCode }}</b> {{ card.totalPremiumAmount }}</p>
                          </div>
                        </div>
                        <div class="card-body">
                          <button class="custom-btn" (click)="openPopup(card)">
                            Read More   <i class="fas fa-arrow-right navIcons"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  }
                  <ng-template #NoPlans>
                    <div class="text-center my-5">
                      <h4>No insurance plans available at the moment.</h4>
                    </div>
                  </ng-template>
                </div>
              </div>
              <!-- Right Section -->
              <div class="col-12 col-lg-4 col-md-10">
                <div class="container mt-4">
                  <div class="summary-card">
                    <h2 class="summary-title">Traveller Summary</h2>
                    <!-- Passenger Details -->
                    <div class="section">
                      <h4 class="section-title">Passengers</h4>
                      <!-- <div class="row detail-row">
                      <div class="col-6 fw-bold">Adults</div>
                      <div class="col-6 text-end">{{ genericReqData.totalAdults }}</div>
                      <div class="col-6 fw-bold">Child</div>
                      <div class="col-6 text-end">{{ genericReqData.totalChild }}</div>
                      <div class="col-6 fw-bold">Infants</div>
                      <div class="col-6 text-end">{{ genericReqData.totalInfants }}</div>
                    </div> -->
                  </div>
                  <!-- Travel Details -->
                  <div class="section">
                    <h4 class="section-title">Travel Details</h4>
                    <div class="row detail-row">
                      <div class="col-6">Departure</div>
                      <div class="col-6 text-end">Departure Date</div>
                    </div>
                    <div class="row detail-row">
                      <div class="col-6">Arrival</div>
                      <div class="col-6 text-end">Not Specifies</div>
                    </div>
                    <div class="row detail-row">
                      <div class="col-6">Issue Date</div>
                      <div class="col-6 text-end">Nothing to say</div>
                    </div>
                    <div class="row detail-row">
                      <div class="col-6">End Date</div>
                      <div class="col-6 text-end">-</div>
                    </div>
                  </div>
                  <!-- Plan Details -->
                  <div class="section">
                    <h4 class="section-title">Selected Plan</h4>
                    <div class="row detail-row">
                      <div class="col-6">Plan Name</div>
                      <div class="col-6 text-end">{{planTitle}}</div>
                    </div>
                    <!-- <div class="row detail-row">
                    <div class="col-6">Amount</div>
                    <div class="col-6 text-end">${{ travellerInfo.plan.amount }}</div>
                  </div>
                  <div class="row detail-row">
                    <div class="col-6">Discount</div>
                    <div class="col-6 text-end">- ${{ travellerInfo.plan.discount }}</div>
                  </div> -->
                  <div class="row detail-row total-row">
                    <div class="col-6 fw-bold">Final Amount</div>
                    <div class="col-6 text-end fw-bold text-primary">{{currencyCode}} {{totalPremium}}</div>
                  </div>
                </div>
                @if (planDetailsVisible0) {
                  <button class="proceed-btn" (click)="procedingthepassenger()">Proceed the Booking</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }





    <div class="protect-terms-rules steps-insur col-sm-12 mt-5" id="step-4-insur">
      <div class="protect-terms-rules-heading">Pending Policy Requests</div>
      <div class="container-fluid bg-light py-3">
        <div class="p-4 col-12" style="display: grid;grid-template-columns: 1fr 1fr 1fr;gap: 0.5rem;">
          @for (req of pendingReqList; track req; let p = $index) {
            <div class="card p-3">
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Request ID: </label>
                <span class="input_lab_value">{{req.requestID}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Area Short Code: </label>
                <span class="input_lab_value">{{req.areaShortCode}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Travel Date: </label>
                <span class="input_lab_value">{{req.travelDate}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Traveler Name: </label>
                <span class="input_lab_value">{{req.travelerName}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">No Of Days: </label>
                <span class="input_lab_value">{{req.noOfDays}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Passport No: </label>
                <span class="input_lab_value">{{req.passportNo}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Contact No: </label>
                <span class="input_lab_value">{{req.contactNo}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Traveler Email: </label>
                <span class="input_lab_value">{{req.travelerEmail}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Plan Type: </label>
                <span class="input_lab_value">{{req.planType}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Plan: </label>
                <span class="input_lab_value">{{req.plan}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Passport No: </label>
                <span class="input_lab_value">{{req.passportNo}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Reference No: </label>
                <span class="input_lab_value">{{req.referenceNo}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Advance Tax: </label>
                <span class="input_lab_value">{{req.advTaxAmount}}</span>
              </div>
              <div class="d-flex justify-content-between align-items-center">
                <label class="input_lab">Policy No: </label>
                <span class="input_lab_value">{{req.policyNo}}</span>
              </div>
              <button class="btn btn-warning" (click)="showIssueCancelDialog()">Confirm Selection</button>
              <p-dialog [(visible)]="displayIssueCancel" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
                <div class="dx-field">
                  <div class="dx-field-label">Select an operation: </div>
                  <div class="dx-field-value">
                    <dx-radio-group id="radio-group-with-selection{{p}}" layout="horizontal"
                      [items]="priorityEntities"
                      valueExpr="id"
                      displayExpr="text"
                      [(value)]="selectionPriorityId">
                    </dx-radio-group>
                  </div>
                </div>
                @if (selectionPriorityId == 1) {
                  <div class="d-flex justify-content-between align-items-center mt-4">
                    <label class="input_lab">Cancellation Remarks: </label>
                    <textarea class="nicnoInput" (keydown)="onRemarksSpacePress($event)" [(ngModel)]="req.remarks"></textarea>
                  </div>
                }
                <button class="btn btn-warning mt-4 mb-4 float-end" (click)="onStepFive(req)">Continue</button>
              </p-dialog>
            </div>
          }
        </div>

      </div>
    </div>
    <p-dialog [(visible)]="showGenerated" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
      <div class="protect-terms-rules col-sm-12" id="step-5-insur">
        <div class="protect-terms-rules-heading">Policy Detail</div>
        <div class="container-fluid bg-light py-3">
          <div class="p-4 col-12">
            @for (insdata of insuranceData; track insdata; let p = $index) {
              <div class="card p-3">
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Request ID: </label>
                  <span class="input_lab_value">{{insdata.requestId}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Reference ID: </label>
                  <span class="input_lab_value">{{insdata.referenceId}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Traveler Name: </label>
                  <span class="input_lab_value">{{insdata.travelerName}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Plan: </label>
                  <span class="input_lab_value">{{insdata.insurancePlan}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Plan Type: </label>
                  <span class="input_lab_value">{{insdata.planType == "S" ? "Single" : "Family"}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Premium: </label>
                  <span class="input_lab_value">{{insdata.premium}}</span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Policy No: </label>
                  <span class="input_lab_value" id="textToCopy">{{insdata.policyNo}} <span class="btn" (click)="copyPolicyNo()"><i class="fas fa-copy"></i></span></span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Policy URL: </label>
                  <span class="input_lab_value"></span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <label class="input_lab">Status: </label>
                  <span class="input_lab_value">Generated</span>
                </div>
              </div>
            }
            <button class="subscribe btn btn-block shadow-sm text-uppercase" (click)="toDashBoard()"><i class="fas fa-angle-double-right"></i> To Dashboard</button>
          </div>
        </div>
      </div>
    </p-dialog>
    <p-dialog [(visible)]="showDBError" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '50vw'}">
      <div class="protect-terms-rules col-sm-12 mt-5">
        <div class="protect-terms-rules-heading">Plan Confirmed Successfully but Database Error Occured</div>
      </div>
    </p-dialog>
  </div>
</main>
<!-- <app-insurance-popup
[title]="selectedCard?.planTitle"
[description]="selectedCard?.planDesc"
[backgroundImage]="selectedCard?.backgroundImage"
[isVisible]="isPopupVisible"
(close)="closePopup()">
</app-insurance-popup> -->